import { useState } from "react";
import BoltIcon from '@mui/icons-material/Bolt';
import {toast, Toaster} from "react-hot-toast";
import "./home.css";
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
export default function Home() {

    const [email, setEmail] = useState("");

    const joinWaitlist = async () => {
        if (!email.trim()) {
            toast.error("Enter a valid email.");
            return;
        }

        const promise = fetch("https://jobsniper-be-production.up.railway.app/waitlist", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ user_email:email })
        }).then(async (res) => {
            if (res.status !== 200) {
                throw new Error("Request failed");
            }
            return res.json();
        });

        toast.promise(
            promise,
            {
                loading: "Adding you to the waitlist...",
                success: "You're in. We'll notify you once JobSniper goes live.",
                error: "Error joining waitlist. Have you already registered? Try again?"
            }
        );
    };
    //https://jobsniper-be-production.up.railway.app/like
    const like = async (l = 1) =>{
        const a = localStorage.getItem("vote");
        const t = toast.loading("recording your vote...")
        if(a === null){
            const res = await fetch("https://jobsniper-be-production.up.railway.app/like",
                {
                    method: "POST",
                    headers:{
                        "Content-Type": "application/json"
                    },
                    body:JSON.stringify({"like": l})
                }
            )
            localStorage.setItem("vote", true);
            toast.success("Your vote is recorded, thanks for voting", {id: t})
        }
        else{
            toast.error("You have already voted! thanks for the vote tho, if you like the idea do let know your friends", {id:t})
        }
    }

    return (
        <div>
            <Toaster 
                position="top-right" 
                toastOptions={{
                    style: { fontSize: "16px", padding: "12px 20px" },
                    success: { duration: 4000 },
                    error: { duration: 4000 }
                }}
            />
            {/* ---------------- HERO ---------------- */}
            <section className="home_hero">
                <div className="title">JobSniper</div>
                <div className="hero_text">
                    <div className="hero_widget_parent">
                        <div className="hero_widget_icon">
                            <BoltIcon />
                        </div>
                        <div>
                            <div className="hero_widget_text">
                                Bridge your skill gap
                            </div>
                        </div>
                    </div>

                    <div className="hero_main_text">
                        Your resume gets you interviews. Your <span className="hero_main_highlight">skills</span> get you the offer.
                    </div>

                    <div className="hero_sub_text">
                        JobSniper is entering private beta. It studies your skills, your tech stack and you, spots what's missing, and builds personalized learning flows. Join early access to get amazing discounts once JobSniper launches.
                    </div>
                </div>
                    {/* FIRST WAITLIST BOX */}
                    <div className="hero_cta" style={{width: window.innerWidth <= 768 ? '85%' : '30%', maxWidth: '600px'}}>
                        {/* INPUT BOX */}
                        <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{width: '100%'}}
                        />

                        <div className="hero_cta_buttons" >
                            {/* CTA BUTTON */}
                            <div
                            onClick={()=>{joinWaitlist()}}
                            className="hero_gradient_cta"
                            >
                                Join Waitlist
                            </div>
                            <a href="#step">
                                <div
                                className="hero_non_gradient_cta"
                                style={{width: '100%'}}
                                >
                                    Learn How It Works
                                </div>
                            </a>
                        </div>
                        <div className="like_the_idea">
                            <div className="hero_sub_text">Like the idea?</div>
                            <div className="buttons_feedback">
                                <button id="button1" onClick={()=>{like()}}><ThumbUpAltIcon /></button>
                                <button id="button2" onClick={()=>{like(-1)}}><ThumbDownAltIcon /></button>
                            </div>
                        </div>
                        <a href="https://jobsniper.vercel.app" className="linktojs">JobSniper is live!! Try it out here</a>
                    </div>
            </section>


            {/* ---------------- HOW IT WORKS ---------------- */}
            <section id="step" className="home_how">
                <div className="home_how_subparent">
                    <div className="hero_main_text">
                        How <span className="hero_main_highlight">JobSniper</span> Works
                    </div>
                    <div className="hero_sub_text">
                        Three simple steps to identify and fix your skill gaps
                    </div>
                </div>

                <div className="step_marker">

                    <div className="step_card">
                        <div className="card_head">Step 1</div>
                        <div className="card_hero">Upload Your Resume</div>
                        <div className="card_subtext">
                            Your skills, stack, strengths, and experience are extracted automatically.
                        </div>
                    </div>

                    <div className="step_card">
                        <div className="card_head">Step 2</div>
                        <div className="card_hero">Upload Your Target JD</div>
                        <div className="card_subtext">
                            We compare what you have with real requirements for that role.
                        </div>
                    </div>

                    <div className="step_card">
                        <div className="card_head">Step 3</div>
                        <div className="card_hero">Get Your Skill-Gap Flow</div>
                        <div className="card_subtext">
                            A tight, actionable flow designed to close your gap quickly.
                        </div>
                    </div>

                </div>
            </section>


            {/* ---------------- FOOTER ---------------- */}
            <section className="footer">
                <div className="footer_hero_parent">
                    <div className="footer_hero">
                        Your Skill Gap Is Costing You <b>Opportunities</b>.
                    </div>
                    <div className="footer_subtext">
                        Join the waitlist and be the first to access JobSniper.
                    </div>
                </div>

                {/* LAST WAITLIST CTA */}
                <div className="hero_cta" >

                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{width: '100%'}}
                    />

                    <div onClick={()=>{joinWaitlist()}} className="hero_gradient_cta" style={{width: '100%'}}>
                        Join Waitlist
                    </div>
                </div>
            </section>

        </div>
    );
}